const quesData = [
    {
        "q_no": 1,
        "question": "Who are eligible to participate in the event?",
        "answer": "The event is open to students from selected college in Bhopal."
    },
    {
        "q_no": 2,
        "question": "What is the registration process for the event?",
        "answer": "To register for the event, fill out the Google form relevant to your institute, make the payment, and attend the event."
    },
    {
        "q_no": 3,
        "question": "Are there any prerequisites or requirements for participating in the event?",
        "answer": "Participants should have a basic understanding of Python."
    },
    {
        "q_no": 4,
        "question": "Do participants need to bring their own laptops for the hackathon?",
        "answer": "Yes, participants are required to bring their own laptops for the hackathon."
    },
    {
        "q_no": 5,
        "question": "What will be the specific topics or themes for the ML/DL hackathon on Kaggle?",
        "answer": "The specific topics/thems for the ML/DL Kaggle hackathon will be revealed on the day of the event itself."
    },
    {
        "q_no": 6,
        "question": "Will participants be allowed to form teams for the hackathon? And what's the maximum team size?",
        "answer": "Yes, participants are allowed to form teams for the hackathon, with a maximum of 3 members from the same institute per team."
    },
    {
        "q_no": 7,
        "question": "What are the guidelines or rules for the hackathon?",
        "answer": "The specific guidelines/rules for the hackathon will be specified in the hackathon details."
    },
    // {
    //     "q_no": 8,
    //     "question": "What criteria will be used for judging the hackathon submissions?",
    //     "answer": "The submissions for the hackathon will be judged using Kaggle."
    // }
];


export default quesData;
